import { useForm } from 'react-hook-form';

import { IDesiredTerms } from 'types/loan';

export const LOAN_FORM_INITIAL_VALUES = {
  principal: 0,
  apr: 0,
  ltv: 0,
  repay: '0',
  term: 12,
  exp: 12,
  interestRate: 0,
  currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
};
function useLoanForm(defaultValues?: Partial<IDesiredTerms>) {
  const initialValues = {
    ...LOAN_FORM_INITIAL_VALUES,
    ...defaultValues,
  };

  return useForm({
    defaultValues: initialValues,
  });
}

export default useLoanForm;
